<template>
    <v-card>
        <v-card-title>
            <h1>{{  title }}</h1>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="fa-search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="data" :pagination.sync="pagination" :total-items="pagination.totalItems" hide-actions>
            <v-progress-linear v-if="loading" slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <td v-for="h in headers" :class="{'text-xs-center' : h.align == 'center', 'text-xs-left' : h.align == 'left', 'text-xs-right' : h.align == 'right'}">
                    <span v-if="h.href">
                        <v-btn :href="getLink(props.item, h)">{{ h.text }}</v-btn>
                    </span>
                    <span v-else-if="h.value == 'created_at'">
                        {{ formatDate(findCelData(props.item, h.value)) }}
                    </span>
                    <span v-else>
                        {{ findCelData(props.item, h.value) }}
                    </span>
                </td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination v-model="current_page" :length="pages"></v-pagination>
        </div>
    </v-card>
</template>

<script>

    const request = require('superagent');
    const debounce = require('debounce');

    export default {
        props : ['url', 'title'],
        data : function(){
            return {
                loading : false,
                data : [],
                headers : [],
                search: '',
                pagination: {sortBy: 'created_at', descending:true},
                search : '',
                current_page : 1
            }
        },
        mounted() {
            var g = this;
            this.loading = true;
            this.getData().end((err, res) => {
                g.data = res.body.data;
                g.headers = res.body.headers;
                g.pagination.sortBy = res.body.sortBy;
                g.loading = false;
                g.pagination.totalItems = res.body.total;
                g.pagination.rowsPerPage = res.body.per_page;
              });
        },
        computed : {
            pages : function() {
                if (this.pagination.rowsPerPage == null ||
                  this.pagination.totalItems == null
                ) return 0
                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            }
        },
        methods : {
            getData : function(){
                this.loading = true;
                const { sortBy, descending, page, rowsPerPage } = this.pagination;
                return request
                  .get(this.url)
                  .query({ page: this.current_page, sort: (descending ? 'desc' : 'asc' ), sortBy : sortBy, search : this.search });
            },
            findCelData : function(item, v){
                var seg = v.split('.');
                if (seg.length == 1){
                    return item[seg[0]];
                }
                if (seg.length == 2 && item[seg[0]] != null){
                    return item[seg[0]][seg[1]];
                }
                if (seg.length == 3 && item[seg[0]] != null){
                    return item[seg[0]][seg[1]][seg[2]];
                }
            },
            formatDate : function(d){
                //2019-02-14 13:01:51
                d = d.replace(' ', 'T') + ".000Z";
                var dd  = new Date(d);
                return dd.toLocaleDateString("en-US");
            },
            getLink : function(item, h){
                return h.href.replace('__1__', this.findCelData(item, h.value))
            }
        },
        watch : {
            pagination: {
                handler (v, o) {
                    if (v.descending != o.descending || v.sortBy != o.sortBy){
                        var g = this;
                        this.loading = true;
                        this.getData().end((err, res) => {
                            g.data = res.body.data;
                            g.loading = false;
                        });
                    }
                },
                deep: true
            },
            current_page : function(){
                var g = this;
                this.loading = true;
                this.getData().end((err, res) => {
                    g.data = res.body.data;
                    g.loading = false;
                });
            },
            search : debounce(function(){
                var g = this;
                this.loading = true;
                this.getData().end((err, res) => {
                    g.data = res.body.data;
                    g.pagination.page = 1;
                    g.pagination.totalItems = res.body.total;
                    g.pagination.rowsPerPage = res.body.per_page;
                    g.loading = false;
                });
            }, 1000)
        }
    }
</script>
